import { ChartTheme } from './chartTheme'

/** Everything that comes from the database or the API is escaped before it goes into tooltip HTML. */
export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export type TipRow = { label: string; value: string; color?: string }

/**
 * A self-contained tooltip card. Colours come from the theme so it is readable in both modes, and
 * the text wraps (see LiveChartFrame) instead of running out of the chart and being cut off.
 */
export function tooltipHtml(
  theme: ChartTheme,
  title: string,
  rows: TipRow[],
  note?: string
): string {
  const body = rows
    .map(
      (r) =>
        `<div class="live-tip-row">` +
        (r.color
          ? `<span class="live-tip-dot" style="background:${escapeHtml(r.color)}"></span>`
          : '') +
        `<span class="live-tip-label">${escapeHtml(r.label)}</span>` +
        `<span class="live-tip-value">${escapeHtml(r.value)}</span></div>`
    )
    .join('')
  return (
    `<div class="live-tip" style="background:${theme.surface};color:${theme.text};border:1px solid ${theme.border}">` +
    `<div class="live-tip-title" style="border-bottom:1px solid ${theme.border}">${escapeHtml(
      title
    )}</div>` +
    body +
    (note
      ? `<div class="live-tip-note" style="color:${theme.muted}">${escapeHtml(note)}</div>`
      : '') +
    `</div>`
  )
}
